import { render, staticRenderFns } from "./BotConfiguration.vue?vue&type=template&id=2c17e3dc&scoped=true&"
import script from "./BotConfiguration.vue?vue&type=script&lang=js&"
export * from "./BotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BotConfiguration.vue?vue&type=style&index=0&id=2c17e3dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17e3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c17e3dc')) {
      api.createRecord('2c17e3dc', component.options)
    } else {
      api.reload('2c17e3dc', component.options)
    }
    module.hot.accept("./BotConfiguration.vue?vue&type=template&id=2c17e3dc&scoped=true&", function () {
      api.rerender('2c17e3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/components/BotConfiguration.vue"
export default component.exports